import React from 'react';

export default function Footer() {
  return (
    <footer>
      <h1><a href='./'>TFP v2</a></h1>
      <a
        href="https://leodeslf.com/"
        title="Portafolio">
        Leo de S.L.F
      </a>
    </footer>
  );
}
